import { Spacer } from '@zillow/constellation';

import { BodyStyledComponent } from '../BodyStyledComponent';
import { TextStyledComponent } from '../TextStyledComponent';

import type { ParagraphStyledComponentProps } from '../../model/ParagraphStyledComponent';

export const ParagraphStyledComponent = ({
  heading,
  body,
  type,
  csEventsHandler,
  csEventsIdMap,
}: ParagraphStyledComponentProps & {
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
}) => {
  return (
    <>
      {heading?.length > 0 && (
        <Spacer>
          {heading.map((h, i) => (
            <TextStyledComponent key={i} styledComponentContent={h} />
          ))}
        </Spacer>
      )}
      <div datatest-id="BodyStyledComponentSpacer">
        <BodyStyledComponent
          sentences={body}
          type={type}
          csEventsHandler={csEventsHandler}
          csEventsIdMap={csEventsIdMap}
        />
      </div>
    </>
  );
};
